import P from './P';

export default P;
